const blobs = new Map();

// Fetches a sticker PNG once and keeps it in memory (instant color swaps + copy)
export function loadPng(url) {
  if (!blobs.has(url)) {
    const p = fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error("load-failed");
        return r.blob();
      })
      .then((b) => {
        const blob = new Blob([b], { type: "image/png" });
        return { blob, objectUrl: URL.createObjectURL(blob) };
      });
    p.catch(() => blobs.delete(url));
    blobs.set(url, p);
  }
  return blobs.get(url);
}
